import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function TrendsIcon(props) {
  const width = props.width || 24;
  const height = props.height || 24;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 3.414L12.707 9.707C12.316 10.098 11.684 10.098 11.293 9.707L7.99997 6.414L3.70697 10.707L2.29297 9.293L7.29297 4.293C7.68397 3.902 8.31597 3.902 8.70697 4.293L12 7.586L17.586 2H14V0H20C20.552 0 21 0.448 21 1V7H19V3.414ZM23 9H19C18.448 9 18 9.448 18 10V23C18 23.552 18.448 24 19 24H23C23.552 24 24 23.552 24 23V10C24 9.448 23.552 9 23 9ZM10 13H14C14.552 13 15 13.448 15 14V23C15 23.552 14.552 24 14 24H10C9.448 24 9 23.552 9 23V14C9 13.448 9.448 13 10 13ZM1 17H5C5.552 17 6 17.448 6 18V23C6 23.552 5.552 24 5 24H1C0.448 24 0 23.552 0 23V18C0 17.448 0.448 17 1 17Z"
          fill="url(#paint0_linear_trends)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_trends"
            x1="-6.68926e-07"
            y1="5.20482"
            x2="11.553"
            y2="28.8111"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
